import React, { Component } from "react";

class SkipLinksChild extends Component {
  constructor() {
    super();

    this.state = {
      focus: false,
    };
    this.handleSkipLinkChildOnFocus = this.handleSkipLinkChildOnFocus.bind(this);
  }

  handleSkipLinkChildOnFocus(event) {
    if (event.type === "focus") {
      if (!this.state.focus) {
        this.setState({ focus: true });
      }
    }
  }

  handleSkipLinkChildOnBlur(event) {
    if (event.type === "blur") {
      if (this.state.focus) {
        this.setState({ focus: false });
      }
    }
  }

  render() {
    return (
      <a
        className={!this.state.focus ? "skplnk-focus" : "skplnk-focus active"}
        aria-label={this.props.aria_label}
        href={this.props.href}
        sktarget={this.props.sktarget}
        onFocus={(event) => this.handleSkipLinkChildOnFocus(event)}
        onBlur={(event) => this.handleSkipLinkChildOnBlur(event)}
      >
        {this.props.link_text}
      </a>
    );
  }
}

export default SkipLinksChild;